module.exports = __webpack_public_path__ + "static/media/logoLab.5bd06067.JPG";